import { MINIMO_RELATO_DE_CIERRE } from './cierre-validacion';

/**
 * "FICHA INCOMPLETA" — la garantía que el técnico cerró sin dejar constancia.
 *
 * El pedido del cliente, textual: "el técnico dice que hizo diez garantías y yo
 * no tengo forma de saber cuáles". Una garantía cerrada sin el relato del
 * técnico y sin su tipificación tiene que VERSE distinta en el listado; si no,
 * la oficina la cuenta igual que las demás.
 *
 * La decisión de si se le adjudica o no la toma el servidor
 * (`services/tecnicos-desempeno.service.ts`) con el MISMO criterio. Acá está
 * solo la lectura de pantalla: si los dos se calcularan distinto, el listado
 * diría una cosa y el reporte otra.
 */

/** Estados en los que el trabajo todavía está en la calle. */
const EN_LA_CALLE = new Set(['ASIGNADO', 'EN_SITIO']);

/** Trabajo, tal como llega de la API, en lo que hace falta para decidir. */
export interface JobConFicha {
  esGarantia?: boolean;
  esRemoto?: boolean | null;
  estado?: string;
  resultado?: string | null;
  nivelResolucionPropuesto?: string | null;
  causaRaizPropuesta?: string | null;
}

/**
 * ¿Mostrar el chip "Ficha incompleta"?
 *
 * No se marca mientras el trabajo sigue en la calle (todavía la puede
 * completar), ni en una garantía cancelada (no hubo visita), ni en una atendida
 * por teléfono (esa la cierra la oficina), ni en un "No terminé" (ahí su
 * entrega es el motivo del catálogo, que ya es obligatorio).
 */
export function fichaIncompletaUI(job: JobConFicha): boolean {
  if (!job.esGarantia) return false;
  if (job.esRemoto) return false;
  const estado = job.estado ?? '';
  if (EN_LA_CALLE.has(estado)) return false;
  if (estado === 'CANCELADO' || estado === 'NO_COMPLETADO') return false;

  const relato = job.resultado?.trim() ?? '';
  if (relato.length < MINIMO_RELATO_DE_CIERRE) return true;
  if (!job.nivelResolucionPropuesto?.trim()) return true;
  if (!job.causaRaizPropuesta?.trim()) return true;
  return false;
}
